export default "__VITE_ASSET__d61DdNFa__"